import React, { Component } from 'react';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import AddButton from '../add-button/index.tsx';
import TypeSelector from '../type-selector/index.tsx';
import image from './assets/image.svg';
import messages from './messages.tsx';

type Props = {
	onAdd: () => void;
};

// eslint-disable-next-line jira/react/no-class-components
export default class LinkSelector extends Component<Props> {
	renderAction = () => <AddButton onClick={this.props.onAdd} ariaLabel={messages.addButtonLabel} />;

	render() {
		return (
			<TypeSelector
				Action={this.renderAction}
				title={getWillShowNav4() ? messages.titleLink : messages.title}
				description={messages.description}
				imageUrl={image}
			/>
		);
	}
}
